module.exports = __webpack_public_path__ + "img/bty.c094a447.jpg";